import { StarRating } from './StarRating/StarRating';

import styles from './DealerRating.module.scss';

export const DealerRating = ({ averageRating = 0 }: { averageRating?: number }) => {
  const clampedRating = Math.max(0, Math.min(averageRating, 5));
  const displayRating = clampedRating.toFixed(1);

  return (
    <div className={styles.wrapper}>
      <StarRating rating={clampedRating} />
      <span>{displayRating}</span>
    </div>
  );
};
